import React from 'react'
import GreyBoxForReports from './GreyBoxForReports'
import { ApiGetCall } from '../../JS/Connector';
import { formatDateToMMDDYYYY, LogInUserID } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';

export default function AllShieldDevices({ setLoading, FilterData, setalerts, downloadAllChecked }) {
    async function GetAllShieldDevicesData() {
        var downloadall = 0;
        if (downloadAllChecked) {
            downloadall = 1;
        }
        setLoading(true);

        setTimeout(() => {
            setalerts(<AlertsComp show={true} variant="success" msg={`You will receive an email notification once matching data is found and processed.`} />);
            setLoading(false);
        }, 3000);

        setTimeout(() => {
            setalerts(<AlertsComp show={false} />);
        }, 5000);

        setTimeout(() => {
            ApiGetCall(`/reports/all-devices?startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}&locationId=${FilterData.Location}&schoolId=${FilterData.School}&userId=${LogInUserID}&flag=${downloadall}`);
        }, 0);
    }
    return (
        <GreyBoxForReports icon="faBuildingShield" name={"All Devices Under Active Coverage"} onclickfunc={GetAllShieldDevicesData} />
    )
}
